export const chartTooltipStyle = {
  backgroundColor: 'hsl(var(--popover))',
  border: '1px solid hsl(var(--border))',
  borderRadius: '8px',
  color: 'hsl(var(--popover-foreground))',
  boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)',
};

export const chartGridStroke = 'hsl(var(--border))';

export const chartAxisTick = {
  fontSize: 12,
  fill: 'hsl(var(--muted-foreground))',
};

export const chartLegendStyle = {
  color: 'hsl(var(--muted-foreground))',
  fontSize: 12,
  lineHeight: '18px',
  paddingTop: 8,
};

export function renderLegendLabel(value) {
  return <span style={{ color: 'hsl(var(--muted-foreground))' }}>{value}</span>;
}

export function getTrendXAxisInterval(windowLabel) {
  const normalized = normalizeTrendWindow(windowLabel);
  if (normalized === '24h') return 3;
  if (normalized === '30d') return 4;
  return 0;
}

export function normalizeTrendWindow(windowLabel) {
  if (windowLabel === 'daily') return '24h';
  if (windowLabel === 'weekly') return '7d';
  if (windowLabel === 'monthly') return '30d';
  return windowLabel || '30d';
}

export function formatTrendTick(value, windowLabel) {
  if (!value) return value;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;

  const normalized = normalizeTrendWindow(windowLabel);
  if (normalized === '24h') {
    return date.toLocaleTimeString(undefined, { hour: 'numeric' });
  }
  if (normalized === '7d') {
    return date.toLocaleDateString(undefined, { weekday: 'short' });
  }
  return date.toLocaleDateString(undefined, { month: 'numeric', day: 'numeric' });
}

export function formatTrendTooltipLabel(value, windowLabel) {
  if (!value) return value;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;

  const normalized = normalizeTrendWindow(windowLabel);
  if (normalized === '24h') {
    return date.toLocaleString(undefined, { month: 'short', day: 'numeric', hour: 'numeric' });
  }
  return date.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' });
}

export function formatShortDateTick(value) {
  return formatTrendTick(value, '30d');
}

export const commonCartesianGridProps = {
  strokeDasharray: '3 3',
  stroke: chartGridStroke,
  vertical: false,
};

export const commonXAxisProps = {
  tick: chartAxisTick,
  tickLine: false,
  axisLine: { stroke: chartGridStroke },
};

export const commonYAxisProps = {
  tick: chartAxisTick,
  tickLine: false,
  axisLine: false,
};

export const commonLegendProps = {
  iconSize: 10,
  wrapperStyle: chartLegendStyle,
  formatter: renderLegendLabel,
};
